module.exports = __webpack_public_path__ + "img/structureChartexample.0638a3a7.svg";